class CategoriesNavigation {
    constructor() {
        this.title = document.querySelector(".articles-navigation > h2");
        this.categories = document.querySelector(".articles-navigation > .category-menu");
        this.events();
    }

    events() {
        if (this.categories) {
            this.title.innerHTML += '<i class="fa-solid fa-chevron-down"></i>';
            this.title.addEventListener('click', (e) => this.handleClick(e));
        }
    };

    handleClick(e) {
        this.categories.classList.toggle('show');
        this.chevron = document.querySelector('.fa-chevron-down');
        this.chevron.classList.toggle('reverse');
    } 

    }

export default CategoriesNavigation;